/**
 * V37.32.5 — single source of truth for result-id URL parsing.
 *
 * Resolves either:
 *   • `?id=…`        (canonical — prompt-list row clicks)
 *   • `?result_id=…` (legacy   — post-generation streaming flow)
 *
 * No internal React state — safe to call inside JSX render, IIFEs,
 * useEffect, or plain utility functions. Both names exported so callers
 * can choose the form that reads cleanest in context (the body is the
 * same; nothing in here triggers rules-of-hooks).
 *
 * Optional `search` arg lets callers pass an explicit query string
 * (e.g. `new URL(href).search`) — falls back to `window.location.search`.
 */
export const getResultIdFromUrl = (search) => {
  try {
    const s = typeof search === 'string'
      ? search
      : (typeof window !== 'undefined' && window.location ? window.location.search : '');
    const params = new URLSearchParams(s);
    return params.get('id') || params.get('result_id') || null;
  } catch (_) {
    return null;
  }
};

// React-hook-style alias (per spec). No state inside, but the name keeps
// component-scope usage idiomatic.
export const useResultId = getResultIdFromUrl;

export default useResultId;
